const translations = {
    pilots: 'Scheduled Pilots',
    pilotsAreRequired: 'At least one pilot is required'
};

export default translations;
